import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import PIDImageContainer from "../../components/PIDImageContainer/PIDImageContainer";
import Header from "../../components/Header";
import ChatPanel from "./ChatPanel";
import PIDTabs from "../../components/PIDTabs";

function PIDFile({ pidFile }) {
  const [toggleChatPanelView, setToggleChatPanelView] = useState(false);

  const handleToggleChatPanelView = () => {
    setToggleChatPanelView((prev) => !prev);
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      position={"relative"}>
      <PIDTabs />
      <Header
        pidFile={pidFile}
        toggleChatPanelView={toggleChatPanelView}
        handleToggleChatPanelView={handleToggleChatPanelView}
      />
      <Box flex={1} overflow={"auto"} position={"relative"}>
        <Grid container height={"100%"}>
          <Grid
            item
            size={{
              md: toggleChatPanelView ? 8 : 12,
            }}
            sx={{
              backgroundColor: (theme) => theme.palette.background.light,
            }}
            height={"100%"}
            width={"100%"}>
            <PIDImageContainer pidFile={pidFile} />
          </Grid>
          {toggleChatPanelView && (
            <Grid
              item
              size={{ md: 4 }}
              height={"100%"}
              sx={{
                borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
                display: "flex",
                flexDirection: "column",
              }}>
              <ChatPanel />
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
}

export default PIDFile;
